module.exports = __webpack_public_path__ + "media/images/sections/home/bride-1055a0e568684a61a1b06a379e2a9623.jpg";